export { getStaticImageSrc } from './get-static-image-src';
